const { __ } = wp.i18n; // Import __() from wp.i18n
const { registerBlockType } = wp.blocks; // Import registerBlockType() from wp.blocks
const { InspectorControls } = wp.blockEditor;
const {
  SelectControl,
  PanelBody,
  PanelRow,
  Placeholder,
  FormTokenField,
} = wp.components;
const { withSelect } = wp.data;
const { createElement: el } = wp.element;
// https://github.com/dgwyer/server-side-render-x
import { ServerSideRenderX } from '../../apidae-archive-block/src/server-side-render-x';
/**
 * Internal dependencies
 */
 import store from '../../../store';
 import icons from "../../../icons.js";

/**
 * Every block starts by registering a new block type definition.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-registration/
 */
registerBlockType( 'wp-apidae/entities', {
	// Block name. Block names must be string that contains a namespace prefix. Example: my-plugin/my-custom-block.
  title: __("Fiches Apidae", "wp-apidae"), // Block title.
  icon: icons.archive, // Block icon from Dashicons → https://developer.wordpress.org/resource/dashicons/.
  description: __("Affiche une sélection de fiches Apidae. Ce bloc est déprécié, Nous vous invitons à utiliser le nouveau système de bloc et modèles", "wp-apidae"),
  keywords: [
    __("apidae fiche", "wp-apidae"),
    __("fiche", "wp-apidae"),
  ],
  supports: {
    align: true,
  },
  example: {
    attributes: {
      types: "",
    },
  },
  attributes: {
    ids: {
      type: "array",
      default: [],
    },
		template:{
			type: "string",
      default: "",
		},
  },


	edit: ({ attributes, setAttributes }) => {
		const { ids, template } = attributes;

		/**
     * Taxonomies
     */
		 const postFilter = withSelect((select) => {
			const { isResolving } = select('core/data');
			const { getEntityRecords } = select('core');
			const postTypeSlugs = ['ad_activite','ad_commerce_et_servi','ad_degustation','ad_patrimoine_cultur','ad_patrimoine_nature','ad_fete_et_manifesta','ad_hebergement_colle','ad_hebergement_locat','ad_hotellerie','ad_hotellerie_plein_','ad_domaine_skiable','ad_equipement','ad_sejour_package','ad_restauration'];
			const postList = [];
			postTypeSlugs.forEach((postType) => {
				const args = ['postType', postType, {per_page: -1}];
	
				if (!isResolving('core', 'getEntityRecords', args)) {
						const result = getEntityRecords('postType', postType, {per_page: -1});
	
						if (result !== null ) {
							result.forEach( ( res ) =>{
								postList.push(res);
							})
						}
				}
		});
      return {
        posts: postList,
      };
    })((props) => {
        let postsNames = [];
        let postsFieldValue = [];

        postsNames = props.posts.map( (post) => post.title.raw );
        postsFieldValue = ids.map( ( postID ) => {
          let wantedPost = props.posts.find( ( post ) => {
            return post.meta.apidae_id === postID;
          } );
          if ( wantedPost === undefined || ! wantedPost ) {
            return false;
          }
          return wantedPost.title.raw;
        } );
        return (
          <FormTokenField
            value={postsFieldValue}
            suggestions={postsNames}
            onChange={ ( ids ) => {
              let selectedPostsArray = [];
              ids.map(
                ( postName ) => {
                  const matchingPost = props.posts.find( ( post ) => {
                    return post.title.raw === postName;
                  } );
                  if ( matchingPost !== undefined ) {
                    selectedPostsArray.push( matchingPost.meta.apidae_id )
                  }
                }
              )
              setAttributes( { ids: selectedPostsArray } );
            } }
            placeholder={__("Ajouter une fiche", "wp-apidae")}
            label={__(
              "Fiches Apidae",
              "wp-apidae"
            )}
          />
        );
		});

		/**
     * Set Card Template.
     */
		 function onChangeCardsTemplates(value) {
      setAttributes({ template: value });
		}

		/**
     * Select Card Template.
     */
		 const cards_templates_select = withSelect((select) => {
      const { isResolving } = select("core/data");
      return {
        cardsTemplatesData: select("wpdae/data").getCardsTemplatesList(),
        isRequesting: isResolving("wpdae/data", "getCardsTemplatesList", []),
      };
    })((props) => {
      if (props.isRequesting) {
        // still resolving; so display a "loading" indicator
        return el("div", null, "Chargement des templates...");
      }

      const cards_templates_list = [{ value: "", label: "Template de base" }];
      for (const [key, value] of Object.entries(props.cardsTemplatesData)) {
        cards_templates_list.push({value: key, label: key});
      }

      return (
        <SelectControl
          onChange={onChangeCardsTemplates}
          value={template}
          label={__("Choisir un template", "wp-apidae")}
          options={cards_templates_list}
        />
      );
		});

    function ShowPlaceHolder(){
      if ( 0 === ids.length ) {
        return (
          <Placeholder
            icon={icons.base}
            label={__("Liste de fiches", "wp-apidae")}
              >
          </Placeholder>
        );
      }
      return (
        <ServerSideRenderX
          block="wp-apidae/entities"
          attributes={{
            ids: ids,
            template: template
          }}
          spinnerLocation={{right: 0, top: 10, unit: 'px'}}
        />
      );
  }

		return([
			<InspectorControls key="inspector">
				<PanelBody title="Configuration">
					<PanelRow>
					{el(postFilter)}
					</PanelRow>
					<PanelRow>
            {el(cards_templates_select)}
          </PanelRow>
				</PanelBody>
			</InspectorControls>,
			ShowPlaceHolder()
		])
	},

	 save: () => {
    return null;
  },
} );
